<style lang="less" scoped>
.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.image {
  width: 100%;
  height: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.avatar_box {
  text-align: center;
  .avatar {
    width: 120px;
    height: 120px;
    display: inline-block;
    margin: 0 auto;
    border-radius: 50%;
    background: #cbd2dd;
    border: 1px solid #cbd2dd;
    overflow: hidden;
    background: url("~css_img/avatar.png") no-repeat center;
    background-size: 100% 100%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}

.pwdstrong {
  margin-top: 6px;
  line-height: 16px;
  font-size: 0;
  margin-right: -3px;
}
.pwdstrong > span {
  display: inline-block;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  width: 33.33%;
  border: 1px solid #fab329;
  color: #fab329;
  margin-left: -1px;
  box-sizing: border-box;
}
.pwdstrong > span.active {
  background-color: #fab329;
  color: #fff;
}
.progress {
  border: 1px solid #e5e7ea;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
  position: relative;
  text-align: center;
  margin-top: 6px;
  line-height: 16px;
  background: none;
  > span {
    height: 16px;
    font-size: 12px;
    line-height: 16px;
    position: absolute;
    left: 50%;
    margin-left: -6px;
    font-weight: 700;
  }
  .porgress_Highlight {
    height: 16px;
    border-radius: 8px;
    transition: 0.5s all;
  }
  .errMsg {
    width: 480px;
    color: #f00;
    font-size: 12px;
    position: absolute;
    top: 18px;
    left: 0;
    text-align: left;
  }
}

.help_block {
  width: 380px;
  color: #737373;
  padding-top: 8px;
  font-size: 12px;
  padding-left: 12px;
  position: relative;
  .errMsg {
    color: #666;
    font-size: 12px;
    position: absolute;
    top: 0;
    left: 16px;
    right: 16px;
    text-align: left;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    padding: 16px;
    box-sizing: border-box;
    > p {
      margin-bottom: 4px;
      > i {
        font-size: 16px;
      }
      .successColor {
        color: #00ff00;
      }
      .errColor {
        color: #ff0000;
      }
    }
  }
}
</style>
<style lang="less">
.pas_error {
  .el-form-item__content .input_tip {
    position: absolute;
    top: 100%;
    left: 0;
    margin-left: 0;
    line-height: 16px;
  }
  .input_tip {
    font-size: 12px;
    color: #c5c5c5;
    line-height: 32px;
    margin-left: 24px;
    &.error {
      color: #f56c6c;
    }
    & > i {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("~css_img/icon_password.png") no-repeat;
      vertical-align: middle;
      margin-right: 8px;
    }
    .i_edf {
      background-position: 0 0;
    }
    .i_error {
      background-position: 0 -17px;
    }
    .i_pwd_weak {
      background-position: 0 -51px;
    }
    .i_pwd_mendium {
      background-position: 0 -34px;
    }
    .i_pwd_strong {
      background-position: 0 -68px;
    }
  }
}
</style>
<template>
  <div class="pas_error">
    <el-form :model="pwwInfo" ref="pwwInfo" label-width="130px" :rules="rules">
      <el-row>
        <el-col :span="10">
          <el-form-item label="登录账号：" prop="loginName">
            <el-input v-model="pwwInfo.loginName" :disabled="true" placeholder="请输入登录账号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="原密码：" prop="originalPass">
            <el-input
              type="password"
              v-model="pwwInfo.originalPass"
              placeholder="请输入原密码"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="新密码：" prop="newPass">
            <el-input
              type="password"
              name="newPass"
              @input="pwStrength(pwwInfo.newPass)"
              v-model="pwwInfo.newPass"
              :trigger-on-focus="false"
              placeholder="请输入新密码"
              auto-complete="off"
            ></el-input>

            <div class="progress">
              <span id="strength_L" v-if="pwwInfo.newPass.length<9" :style="{color:heigColor}">弱</span>
              <span
                id="strength_M"
                v-if="pwwInfo.newPass.length<17 && pwwInfo.newPass.length>8"
                :style="{color:heigColor}"
              >中</span>
              <span id="strength_H" v-if="pwwInfo.newPass.length>16" :style="{color:heigColor}">强</span>
              <div class="porgress_Highlight" :style="higHlight"></div>
              <div class="errMsg">{{errMsg}}</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <div class="help_block" style="padding-top:0;">
            <!-- 说明：密码必须包含字母（区分大小写）、数字和符号两种及以上的组合, 8-20个字符组成 -->
            <div class="errMsg">
              <p>
                <i
                  :class="{'el-icon-circle-close-outline':!pswStrength1,'errColor':!pswStrength1,'el-icon-circle-check-outline':pswStrength1,'successColor':pswStrength1}"
                ></i> 密码由8-20个字符组成
              </p>
              <p>
                <i
                  :class="{'el-icon-circle-close-outline':!pswStrength3,'errColor':!pswStrength3,'el-icon-circle-check-outline':pswStrength3,'successColor':pswStrength3}"
                ></i> 密码必须包含字母（区分大小写）、数字和符号两种及以上的组合
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="确认密码：" prop="newCheckPass">
            <el-input
              type="password"
              name="newCheckPass"
              v-model="pwwInfo.newCheckPass"
              :trigger-on-focus="false"
              placeholder="请输入确认密码"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label>
            <el-button @click="resetPassword" type="primary">保存</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  //    components: {},
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.pwwInfo.newPass) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };

    var validatePass1 = (rule, value, callback) => {
      if (
        /^[A-Z]+$/.test(value) ||
        /^[a-z]+$/.test(value) ||
        /^[0-9]+$/.test(value)
      ) {
        callback(new Error(" "));
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };

    return {
      pwwInfo: {
        loginName: this.$store.state.userInfo.logonName,
        originalPass: "",
        newPass: "",
        newCheckPass: ""
      },
      rules: {
        loginName: [
          { required: true, message: "请输入登录账号", trigger: "blur" }
        ],
        originalPass: [
          { required: true, message: "请输入原密码", trigger: "blur" }
          // { min: 8, max: 20, message: "最小长度8个字符", trigger: "blur" },
        ],
        newPass: [
          // { required: true, message: "请输入新密码", trigger: "blur,change" },
          // { min: 8, max: 20, message: "最小长度8个字符", trigger: "blur" },
          // {required: true, validator: validatePass1, trigger: "blur" }
          { required: true, message: " ", trigger: "blur" },
          { required: true, min: 8, max: 20, message: " ", trigger: "blur" },
          { required: true, validator: validatePass1, trigger: "change" }
        ],
        newCheckPass: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          // { min: 8, message: "最小长度8个字符", trigger: "blur,change" },
          { validator: validatePass2, trigger: "blur" }
        ]
      },
      Lcolor: "",
      Mcolor: "",
      Hcolor: "",
      errMsg: "",
      higHlight: {
        width: "1%",
        backgtound: ""
      },
      heigColor: "#FAB329",
      pswStrength1: false,
      pswStrength3: false
      // avator_url:null,
    };
  },
  props: ["userSetting"],
  mounted() {
    let vm = this;
  },
  methods: {
    resetPassword() {
      let vm = this;
      this.$refs["pwwInfo"].validate(function(valid) {
        if (valid) {
          http
            .post(
              InterfacePrefix["platform"] + "/users/resetPassWord",
              vm.pwwInfo
            )
            .then(function(xhr) {
              if (xhr.data.code) return; // TODO: 异常情况有公共处理
              //         vm.userSetting.user_setting_show=false;
            });
        }
      });
    },
    /*密码强度判断*/
    pwStrength(pwd) {
      // console.log(pwd)

      let vm = this;
      let f_color = "#fff";
      let O_color = "#eeeeee";
      let L_color = "#f84c58";
      let M_color = "#fff61c";
      let H_color = "#67c23a";
      let level = 0,
        strength = "O";
      if (pwd == null || pwd == "") {
        strength = "O";
        vm.Lcolor = vm.Mcolor = vm.Hcolor = O_color;
      } else {
        let mode = 0;
        if (pwd.length == 0) {
          vm.errMsg =
            "密码必须包含字母（区分大小写）、数字和符号两种及以上的组合, 8-20个字符组成";
        } else if (pwd.length < 8 || pwd.length > 20) {
          mode = 0;
          vm.errMsg = "密码由8-20个字符组成";
          vm.pswStrength1 = false;
        } else {
          vm.errMsg = " ";
          vm.pswStrength1 = true;

          //為了跟判斷密碼是否含有數字和大小字母同步如不含有則不判斷強度
          let flag = true;

          // flag = /^[\w\W]{8,20}$/.test(pwd)

          if (
            flag == /^[A-Z]+$/.test(pwd) ||
            flag == /^[a-z]+$/.test(pwd) ||
            flag == /^[0-9]+$/.test(pwd)
          ) {
            flag = false;
            vm.errMsg = "密码必须包含两种及以上的组合";
            vm.pswStrength3 = false;
          } else {
            vm.errMsg = " ";
            vm.pswStrength3 = true;
          }

          //強度模式改為依照長度判斷8位為最弱，9-16位中度，17-20位最強
          // console.log('length', pwd.length)

          //一种 两种
          // console.log('两种',/^(?:\d+|[a-zA-Z]+|[\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/]{7,19})$/.test(pwd))
          // //三种
          // console.log('三种', /^(?![a-zA-Z]+$)(?![0-9]+$)(?![/\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/]+$)[0-9A-Za-z\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/]{7,19}$/.test(pwd))
          // //四种
          // console.log('四种',/^(?:(?=.*[0-9].*)(?=.*[A-Za-z].*)(?=.*[\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/].*))[\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/0-9A-Za-z]{7,19}$/.test(pwd))

          level = 0;
          if (flag) {
            //两种
            if (
              /^(?:\d+|[a-zA-Z]+|[\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/]{7,19})$/.test(
                pwd
              )
            ) {
              level = 1;
            }

            //三种
            if (
              /^(?![a-zA-Z]+$)(?![0-9]+$)(?![/\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/]+$)[0-9A-Za-z\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/]{7,19}$/.test(
                pwd
              )
            ) {
              level = 2;
            }

            //四种
            if (
              /^(?:(?=.*[0-9].*)(?=.*[A-Za-z].*)(?=.*[\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/].*))[\`\~\!@#\$%^\&\*\-\+\=_\(\)\{\}\[\]\|\\:;\"\"\'\'\<\>\,\.\?\/0-9A-Za-z]{7,19}$/.test(
                pwd
              )
            ) {
              level = 3;
            }
          }
        }

        console.log("level", level);

        switch (level) {
          case 0:
            strength = "O";
            if (pwd.length < 8) {
              vm.higHlight.width = "0";
              vm.higHlight.background = O_color;
            }
            if (pwd.length < 21 && pwd.length > 16) {
              vm.higHlight.width = "100%";
              vm.higHlight.background = H_color;
              vm.heigColor = "#fff";
            }
            break;
          case 1:
            break;
          case 2:
            vm.higHlight.width = "70%";
            vm.higHlight.background = M_color;
            vm.heigColor = "#ff0000";
            break;
        }
      }

      if (pwd.length == 8) {
        vm.higHlight.width = "40%";
        vm.higHlight.background = O_color;
      }
      return strength;
    },

    closedialog() {
      //  this.userSetting.user_setting_show=false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/setting/basic_information/password_setting.vue